module.exports = __webpack_public_path__ + "img/symbol_7.0102f1e9.png";